export default class VerfuegungVersandKonfigDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.id = json.id
      this.gpId = json.gpId
      this.elektronisches = json.elektronisches
      this.createdOn = json.createdOn
      this.createdBy = json.createdBy
      this.archivedOn = json.archivedOn
    } else {
      this.json = {}
    }
  }
}
